import { create } from "zustand";
import { SortType } from "@/types/referals";

interface SortTypeState {
  sortType: SortType;
  setSortType: (elem: SortType) => void;
}

export const SORT_TYPE_PARAMS: Record<SortType, string> = {
  max: "benefit:desc",
  min: "benefit:asc",
  new: "date:desc",
  old: "date:asc",
};

export const DEFAULT_SORT_TYPE: SortType = "old";
export const DEFAULT_SORT_PARAM = SORT_TYPE_PARAMS[DEFAULT_SORT_TYPE];

export const useSortTypeStore = create<SortTypeState>()((set) => ({
  sortType: DEFAULT_SORT_TYPE,
  setSortType: (elem) =>
    set(() => ({
      sortType: elem,
    })),
}));
